@if (liveDataInitialCount) {
  <div class="p-2 py-3 p-lg-2 text-body user-stat-card">
    <div class="d-flex gap-1 gap-lg-5 flex-wrap">
      <div>
        <dt>
          {{ selectedUser?.id ? "Current Shift" : "Guarding Overview" }}
        </dt>
      </div>
      <div>
        @if (routedToPage || !selectedUser?.id) {
          <div class="d-flex justify-content-end">
            <div class="d-flex gap-3">
              @if (userLiveDataList?.length) {
                <div
                  [class.opacity-75]="disableExportBtn"
                  role="button"
                  class="d-flex align-items-center gap-2 bg-success text-white border rounded py-0 px-3 fw-medium"
                  (click)="
                    !disableExportBtn
                      ? exportData(exportOperationsOverviewTemplate)
                      : ''
                  "
                >
                  <span> Export </span>

                  @if (disableExportBtn && exportEnableRemSeconds) {
                    <span class="small">{{ exportEnableRemSeconds }}</span>
                  } @else {
                    <span>
                      <i class="fa-regular fa-file-excel"></i>
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (!largeView && liveDataInitialCount > 3 && routedToPage) {
      <div class="row row-cols-1 row-cols-lg-2 my-2">
        <div class="input-group">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              placeholder="Site / Name"
              (input)="filterData('site')"
              [(ngModel)]="mobileFilterStringDict.site"
            />
            <label>Site / Name</label>
          </div>

          @if (mobileFilterStringDict?.site) {
            <span
              class="input-group-text"
              (click)="
                mobileFilterStringDict.site = ''; filterData('site', true)
              "
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
        @if (!selectedUser?.id) {
          <div class="input-group">
            <div class="form-floating">
              <input
                class="form-control"
                type="text"
                placeholder="Guard"
                (input)="filterData('guard')"
                [(ngModel)]="mobileFilterStringDict.guard"
              />
              <label>Guard</label>
            </div>

            @if (mobileFilterStringDict?.guard) {
              <span
                class="input-group-text"
                (click)="
                  mobileFilterStringDict.guard = ''; filterData('guard', true)
                "
              >
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
        }
      </div>
    }

    <gtapp-gt-custom-table
      [deskTopTableData]="userLiveDataList"
      [desktopTableDetails]="userLiveTableInfo"
      [otherParams]="otherParamsUserLiveData"
      [tableStyle]="{
        'overflow': 'auto',
        'max-height': routedToPage ? '80vh' : '40vh',
      }"
      (paginationChange)="onChangePaginationUserLiveData($event)"
      (rowClick)="routeToUserStatsORJob($event)"
      (sortColumn)="sortColumnUserLiveData($event)"
      (searchColumn)="searchColumnUserLiveData($event)"
    >
    </gtapp-gt-custom-table>
  </div>
}

<ng-template
  #exportOperationsOverviewTemplate
  let-exportOperationsOverviewTemplate="dialogRef"
  let-data
>
  <div class="card dialog-box" data-bs-theme="light">
    <div class="card-header">Export</div>
    <div class="mb-4 d-flex row-gap-3 column-gap-5 flex-wrap px-lg-3 px-2">
      <div>
        @if (data.editDate) {
          <div class="form-floating">
            <input
              class="form-control"
              type="date"
              placeholder="Pick Date"
              [(ngModel)]="data.report_date"
              [max]="data?.maxReportDate"
              [class.is-invalid]="data?.report_date > data?.maxReportDate"
              (ngModelChange)="checkExportStatus(data)"
            />
            <label>Pick Date</label>
          </div>
        } @else {
          <dl>
            <dt>Date</dt>
            <dd>
              {{ data?.report_date | customDate: "d MMM y" }}
              <span class="edit-button" (click)="data.editDate = true"></span>
            </dd>
          </dl>
        }
      </div>
      <div>
        @if (data?.sub_contractor?.id) {
          <dl>
            <dt>Subcontractor</dt>
            <dd>
              {{ data?.sub_contractor?.company_name }}
              <span
                class="edit-button"
                (click)="
                  data.sub_contractor = {};
                  focusElement('subContractorLookupFieldId');
                  checkExportStatus(data)
                "
              ></span>
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="subContractorData.data"
            placeHolder="Select Sub contractor"
            searchKeyword="company_name"
            [itemTemplate]="subContractorLookupTemplate"
            (inputChanged)="getSubContractors($event)"
            (selected)="data.sub_contractor = $event; checkExportStatus(data)"
            inputId="subContractorLookupFieldId"
          >
          </gtapp-auto-complete>

          <ng-template #subContractorLookupTemplate let-item>
            <div>{{ item?.company_name }}</div>
          </ng-template>
        }
      </div>
    </div>
    @if (!data?.report_exists) {
      <div class="p-3 text-center text-danger small fw-semibold">
        No records found
      </div>
    }
    <div class="d-flex gap-2">
      <button
        class="btn btn-lg btn-dark w-100"
        (click)="exportOperationsOverviewTemplate.close()"
      >
        Cancel
      </button>
      <button
        class="btn btn-lg btn-success w-100"
        [disabled]="!data?.report_date || !data?.report_exists"
        (click)="exportOperationsOverviewTemplate.close(data)"
      >
        Export
      </button>
    </div>
  </div>
</ng-template>
